import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import app from "../../core/application";
import {sendRequest} from "../../helpers/ajax";
import IPasswordIsValidRequest from "../../types/IPasswordIsValidRequest";
import IPasswordIsValidResponse from "../../types/IPasswordIsValidResponse";
import IResetPasswordRequest from "../../types/IResetPasswordRequest";
import IResetPasswordResponse from "../../types/IResetPasswordResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import IValidateResetPasswordKeyRequest from "../../types/IValidateResetPasswordKeyRequest";
import IValidateResetPasswordKeyResponse from "../../types/IValidateResetPasswordKeyResponse";
import ResetPassword from "./ResetPassword";

interface IResetPasswordContainerProps extends RouteComponentProps<any> {
    onLogin: (userSession: IUserSession) => void;
}

class ResetPasswordContainer extends React.Component<IResetPasswordContainerProps>{

    constructor(props: IResetPasswordContainerProps) {
        super(props);

        this.validateResetCode = this.validateResetCode.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.validatePasswordRequirements = this.validatePasswordRequirements.bind(this);
    }

    public render() {
        return (
            <ResetPassword 
                validateResetCode={this.validateResetCode} 
                resetPassword={this.resetPassword}
                validatePasswordRequirements={this.validatePasswordRequirements}
            />
        );
    }

    private validateResetCode(): Promise<IResponse<IValidateResetPasswordKeyResponse> | null>  {
        //  Get the registration key from the URL
        const resetCode = this.props.match.params.resetCode as string;

        const request: IValidateResetPasswordKeyRequest = { resetCode };
        return sendRequest<IResponse<IValidateResetPasswordKeyResponse>>("/api/Authentication/ValidateResetPasswordKey", "POST", request);
    }

    private async resetPassword(password: string, confirmPassword: string, resetCode: string): Promise<IResponse<IResetPasswordResponse> | null> {
        const request: IResetPasswordRequest = { password, resetCode };
        const response = await sendRequest<IResponse<IResetPasswordResponse>>("/api/Authentication/ResetPassword", "POST", request);

        if (response && response.success && response.payload && response.payload.success && response.payload.userSession) {
            // successful login
            app().logInUser(response.payload.userSession);
            this.props.onLogin(response.payload.userSession);
        }
        return response;
    }

    private  validatePasswordRequirements(password: string): Promise<IResponse<IPasswordIsValidResponse> | null>  {
        const request: IPasswordIsValidRequest = { password };
        return sendRequest<IResponse<IPasswordIsValidResponse>>("/api/PasswordRequirements/IsValid", "POST", request);
    }

}

export default withRouter(ResetPasswordContainer);




// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPasswordContainer.tsx